<div class="t-popup popup-patientDetails">
  <div class="t-popup-close"></div>
  <div class="t-popup-frame" style="width: 65em; max-width: fit-content">
    <div class="t-popup-body" [formGroup]="concentForm">
      <button
        class="t-btn-popup-close"
        matTooltip="Close Popup"
        aria-label="close popup"
        (click)="close(false)"
      ></button>

      <div class="m-box w100" style="direction: rtl; font-size: 20px; position: relative;">
        <!-- X close button top-right -->
        <button
          (click)="close(false)"
          style="position: absolute; top: 0.3em; right: 0.5em; background: none; border: none; font-size: 1.4em; cursor: pointer; z-index: 2; line-height: 1;"
          matTooltip="סגור"
          aria-label="סגור"
        >&#x2715;</button>
        <!-- Icons: absolute top-left so they never push content -->
        <div style="position: absolute; top: 0.3em; left: 0.5em; display: flex; align-items: center; gap: 0.5em; z-index: 1;">
          <div *ngIf="waitingForSignatures" style="border: 1px solid black; padding: 0.2em 0.4em; font-size: 0.7em;">
            ממתין לחתימה
          </div>
          <div *ngIf="errorInSignature" style="border: 1px solid red; padding: 0.2em 0.4em; font-size: 0.7em; color: red;">
            חסרות חתימות
          </div>
          <span
            class="l-header-panel header-menu-link icon-link concent-link"
            (click)="handleSaveAndShowLink()"
            style="cursor: pointer;"
            aria-label="Send Link"
            matTooltip="שלח קישור לחתימה"
          ></span>
          <span
            (click)="printConsent()"
            class="header-menu-link icon-print"
            aria-label="Print"
            matTooltip="Print"
            style="filter: invert(39%) sepia(8%) saturate(4116%) hue-rotate(143deg) brightness(60%) contrast(78%); cursor: pointer;"
          ></span>
        </div>

        <h2 style="text-align: center; margin-bottom: 0.3em;">{{ consentDef.title }}</h2>

        <!-- Patient Info -->
        <div class="r-concent" style="display: flex; gap: 1em; flex-wrap: wrap; margin-bottom: 1em">
          <label class="t-label-top">
            <span>שם משפחה</span>
            <input class="t-field t-input" formControlName="Last" />
          </label>
          <label class="t-label-top">
            <span>שם פרטי</span>
            <input class="t-field t-input" formControlName="First" />
          </label>
          <label class="t-label-top">
            <span>ת.ז.</span>
            <input class="t-field t-input" formControlName="ID" />
          </label>
          <label class="t-label-top">
            <span>טלפון</span>
            <input class="t-field t-input" formControlName="Phone" />
          </label>
        </div>

        <!-- Consent Text -->
        <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
          <div class="w100" style="display: flex; margin: 0.3em; flex-direction: column;">
            <ng-container *ngFor="let block of consentDef.body">
              <h3 *ngIf="block.heading">{{ block.heading }}</h3>
              <p *ngFor="let p of block.paragraphs">{{ p }}</p>
              <ul *ngIf="block.bullets">
                <li *ngFor="let b of block.bullets">{{ b }}</li>
              </ul>
            </ng-container>
          </div>
        </div>

        <!-- Patient declaration + date/time -->
        <div class="m-box" style="direction: rtl; margin: 1em 0;">
          <div class="w100" style="display: flex; margin: 0.3em; flex-direction: column;">
            <h3>הצהרת המטופל וחתימות</h3>
            <p>אני מצהיר/ה כי:</p>
            <ul>
              <li>קיבלתי הסבר על מטרת הבדיקה, אופן ביצועה, יתרונותיה מגבלותיה והאלטרנטיבות.</li>
              <li>הוסברו לי הסיכונים ותופעות הלוואי האפשריים.</li>
              <li>ניתנה לי אפשרות לשאול שאלות, וכל שאלותיי נענו לשביעות רצוני.</li>
              <li *ngFor="let line of consentDef.consentLines">{{ line }}</li>
            </ul>
          </div>
        </div>

        <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 0.5em; margin-bottom: 0.5em">
          <p style="margin: 0;">אני מצהיר/ה ומאשר/ת בזאת שקיבלתי הסבר מפורט בעל פה מ:</p>
          <span class="t-field t-field--number" style="direction: rtl;">
            <input class="t-field-text" type="text" formControlName="refferalDoc" />
          </span>
        </div>
        <div style="display: flex; justify-content: space-evenly; margin-bottom: 1em;">
          <div class="w20" style="display: flex; margin-top: 0.3em;">
            <span style="margin-left: 0.3em; align-self: center;">יום:</span>
            <span class="t-field t-field--number" style="direction: rtl;">
              <p class="t-field-text">{{ concentForm.get('CreationTime').value | date:'EEEE' | translateDay }}</p>
            </span>
          </div>
          <div class="w20" style="display: flex; margin-top: 0.3em;">
            <span style="margin-right: 1.5em; align-self: center;">תאריך:</span>
            <span class="t-field t-field--number" style="direction: rtl;">
              <p class="t-field-text">{{ concentForm.get('CreationTime').value | date:'dd.MM.yyyy' }}</p>
            </span>
          </div>
          <div class="w30" style="display: flex; margin-top: 0.3em; margin-right: 2em;">
            <span style="margin-right: 1.5em; align-self: center;">שעה:</span>
            <span class="t-field t-field--number" style="direction: rtl;">
              <p class="t-field-text">{{ concentForm.get('CreationTime').value | date:'HH:mm' }}</p>
            </span>
          </div>
        </div>

        <!-- Patient signature -->
        <div style="display: grid">
          <span>חתימת המטופל/ת:</span>
          <canvas
            #canvas
            [style.border]="'1px solid black'"
            [ngClass]="'can-shadow'"
            width="300"
            height="200"
            style="cursor: crosshair"
          ></canvas>
          <button style="position: relative; top: -2em; width: fit-content;" (click)="clear('patSign')" [disabled]="lockedConsent">
            <img src="../../assets/icons/login/reset.png" style="height: 1.5em; width: 1.5em" matTooltip="Clear">
          </button>
        </div>

        <!-- Doctor confirmation + date/time + signature -->
        <div style="margin-top: 2em; padding-top: 0.8em; border-top: 1px solid #ccc; font-size: 1em; font-weight: normal;">
          אני מאשר כי הסברתי למטופל/ת את מטרת הבדיקה, אופן ביצועה, מגבלותיה, הסיכונים האפשריים והמשך הבירור הצפוי במקרה של תוצאה חריגה, וכי התרשמתי שהמטופל/ת הבין/ה את ההסבר ונתן/ה הסכמה מדעת.
        </div>
        <div style="display: flex; justify-content: space-evenly; margin-bottom: 3%;">
          <div class="w20" style="display: flex; margin-top: 0.3em;">
            <span style="margin-left: 0.3em; align-self: center;">יום:</span>
            <span class="t-field t-field--number" style="direction: rtl;">
              <p class="t-field-text">{{ concentForm.get('CreationTime').value | date:'EEEE' | translateDay }}</p>
            </span>
          </div>
          <div class="w20" style="display: flex; margin-top: 0.3em;">
            <span style="margin-right: 1.5em; align-self: center;">תאריך:</span>
            <span class="t-field t-field--number" style="direction: rtl;">
              <p class="t-field-text">{{ concentForm.get('CreationTime').value | date:'dd.MM.yyyy' }}</p>
            </span>
          </div>
          <div class="w30" style="display: flex; margin-top: 0.3em; margin-right: 2em;">
            <span style="margin-right: 1.5em; align-self: center;">שעה:</span>
            <span class="t-field t-field--number" style="direction: rtl;">
              <p class="t-field-text">{{ concentForm.get('CreationTime').value | date:'HH:mm' }}</p>
            </span>
          </div>
        </div>
        <div style="display: flex; flex-direction: row-reverse; justify-content: right; margin-bottom: 0.5em;">
          <span class="t-field t-field--number" style="direction: rtl;">
            <input class="t-field-text" type="text" formControlName="refferalDoc" />
          </span>
        </div>

        <!-- Doctor Signature -->
        <div style="display: grid; margin-bottom: 1em;">
          <span>חתימת הרופא/ה:</span>
          <canvas
            #canvasDoc
            [style.border]="'1px solid black'"
            [ngClass]="'can-shadow'"
            width="300"
            height="200"
            style="cursor: crosshair"
          ></canvas>
          <button style="position: relative; top: -2em; width: fit-content;" (click)="clear('docSign')" [disabled]="lockedConsent">
            <img src="../../assets/icons/login/reset.png" style="height: 1.5em; width: 1.5em" matTooltip="Clear">
          </button>
        </div>

        <!-- Actions -->
        <div *ngIf="!lockedConsent" class="btn-row" style="margin-top: 1em;">
          <button class="button-cancel" (click)="close(false)">ביטול</button>
          <button
            class="button-save"
            [disabled]="toggleSave()"
            (click)="ce.errorCalendar('Save Consent Form?')"
          >
            שמור טופס חתום
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-send-link
  *ngIf="showlink"
  (closed)="closeSendLinks($event)"
  [exam]="null"
  [isUsgConsent]="true"
  [concent]="concentForm.value"
  (closeFromLinks)="closeFromLinks($event)"
></app-send-link>
